import * as MicrosoftGraph from '@microsoft/microsoft-graph-types';
import { ApplicationException } from 'common/exceptions/application/ApplicationException';
import CONFIG from 'config';
import { CommunicationTemplate } from '../models/CommunicationTemplate';
import { Stakeholder } from '../models/Stakeholder';
import * as GraphApi from '../utils/graphApi';
import * as UserSettings from '../utils/user-settings';
import { ContactCustomFields } from './../models/ContactCustomFields';

const TAG = 'OCT3: ';

export async function createAutosaveContact(
  projectId: string,
  emailType: string,
  stakeholder: Stakeholder,
  communicationTemplate: CommunicationTemplate,
  firstSaveDate: Date
) {
  console.log(TAG, 'Saving contact ', stakeholder.Email);

  const existingContact = await GraphApi.getContact(
    stakeholder.Email,
    CONFIG.contactGroupName
  );

  const contact: MicrosoftGraph.Contact = {
    givenName: stakeholder.FirstName,
    surname: stakeholder.LastName,
    emailAddresses: [
      {
        address: stakeholder.Email,
        name: stakeholder.FirstName + ' ' + stakeholder.LastName,
      },
    ],
    children: [],
  };

  // preserve ID of existing contact
  if (existingContact) contact.id = existingContact.id;

  const customFields = new ContactCustomFields();
  customFields.domainUrl = UserSettings.getDomain();
  customFields.clientId = UserSettings.getClientCode();
  customFields.projectId = projectId;
  customFields.emailType = emailType;
  customFields.stakeholder = stakeholder;
  customFields.communicationTemplate = communicationTemplate;
  customFields.lastSyncDate = firstSaveDate;
  customFields.startAutosaveDate = firstSaveDate;

  console.log(
    TAG,
    'Domain and client for the contact ',
    customFields.domainUrl,
    customFields.clientId
  );

  // preserve startAutosaveDate of existing contact
  if (existingContact) {
    const existingCustomFields = getCustomFields(existingContact);
    customFields.startAutosaveDate = existingCustomFields.startAutosaveDate;
  }

  setCustomFields(contact, customFields);

  // TODO: do not update start save date!
  await GraphApi.createOrUpdateContact(contact, CONFIG.contactGroupName);
  console.log(TAG, 'Done saving contact');
}

export function setCustomFields(
  contact: MicrosoftGraph.Contact,
  customFields: ContactCustomFields
) {
  console.log(
    TAG,
    'Setting contact fields ',
    contact.emailAddresses[0].address,
    customFields
  );

  contact.personalNotes = JSON.stringify(customFields);
}

export function getCustomFields(
  contact: MicrosoftGraph.Contact
): ContactCustomFields {
  const emailAddress = contact.emailAddresses[0].address;

  try {
    // deserialize to specific type
    const parsed = Object.assign(
      new ContactCustomFields(),
      JSON.parse(contact.personalNotes)
    ) as ContactCustomFields;

    if (!parsed.updateDate) {
      throw new ApplicationException('updateDate property not set');
    }

    console.log(TAG, 'Read contact fields ', emailAddress, parsed);

    return parsed;
  } catch (error) {
    throw new ApplicationException(
      `Failed to parse custom fields for contact ${emailAddress}. Data: '${contact.personalNotes}'`,
      error
    );
  }
}

export async function setLastSyncDate(
  contact: MicrosoftGraph.Contact,
  date: Date
) {
  console.log(TAG, 'Setting last sync date to ', date);
  const customFields = getCustomFields(contact);
  if (customFields && customFields.lastSyncDate > date) {
    console.log(TAG, 'Setting last sync date: already greater than ', date);
    return;
  }
  customFields.lastSyncDate = date;
  setCustomFields(contact, customFields);
  await GraphApi.updateContact(contact);
}
